import isNil from 'lodash/isNil';
import { gtmTracker } from '../../taboola-common-frontend-modules/gtmTracker';
import { SET_FATAL_ERROR, setFatalError } from '../actions';

const handledErrors = new WeakSet();

const errorMiddleware = store => {
    const handleFatalError = payload => {
        if (payload?.error?.fatal) {
            return;
        }

        handleError(payload);
    };

    const handleError = error => {
        if (handledErrors.has(error)) {
            return;
        }

        if (error?.error?.fatal) {
            store.dispatch(setFatalError(error));
        }
        let errorToPrint = error;
        if (isNil(error)) {
            errorToPrint = new Error('Unhandled Error');
        }

        gtmTracker.trackError(errorToPrint);
        console.error(errorToPrint);
        handledErrors.add(errorToPrint);
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleError);

    const callback = next => action => {
        if (action.error) {
            const { error } = action;
            handleError(error);
            return store.dispatch(setFatalError(error));
        }

        if (action?.type === SET_FATAL_ERROR) {
            handleFatalError(action.payload);
        }

        try {
            let nextAction = next(action);
            if (nextAction instanceof Promise) {
                nextAction = nextAction.catch(e => {
                    handleError(e);
                    throw e;
                });
            }

            return nextAction;
        } catch (e) {
            handleError(e);
            throw e;
        }
    };
    return callback;
};

export default errorMiddleware;
